import moment from "jalali-moment";

export const convertDate = (date, time = true) => {
  if (date) {
    const shamsi = moment(date).format(
      time ? "jYYYY/jMM/jDD (HH:mm:ss)" : "jYYYY/jMM/jDD"
    );
    return shamsi;
  } else {
    return "-";
  }
};

export const convertOnlyTime = (date) => {
  if (date) {
    const shamsi = moment(date).format("HH:mm");
    return shamsi;
  } else {
    return "-";
  }
};
